import { ClockIcon } from '@eventbrite/marmalade';
import React from 'react';

import styles from './OperatingHoursButton.module.scss';

interface OperatingHoursButtonButtonProps {
    onClick?: () => void;
}

export const OperatingHoursButton: React.FC<OperatingHoursButtonButtonProps> = (
    props: OperatingHoursButtonButtonProps,
) => {
    const { onClick } = props;

    return (
        <button className={styles.operatingHoursButton} onClick={onClick}>
            <div className={styles.clockIcon}>
                <ClockIcon size="small" />
            </div>
            <div className={styles.buttonText}>
                <p>View operating hours</p>
            </div>
        </button>
    );
};
